export interface Data<T> {
  loading: boolean;
  loaded: boolean;
  errorMessage: string | null;
  data: T;
}

export function loading<T>(data: T): Data<T> {
  return {
    loaded: false,
    loading: true,
    errorMessage: null,
    data,
  };
}

export function loaded<T>(data: T): Data<T> {
  return {
    loaded: true,
    loading: false,
    errorMessage: null,
    data,
  };
}

export function error<T>(errorMessage: string): Data<T> {
  return {
    loaded: false,
    loading: false,
    errorMessage,
    data: null,
  };
}

export function empty<T>(): Data<T> {
  return {
    loaded: false,
    loading: false,
    errorMessage: null,
    data: null,
  };
}
